import { type ParamsField } from '@/stores/apiTab.store'

/**
 * Removes the next row in the `rows` array if the current row and the next
 * row are both empty (i.e., all properties are empty strings).
 * The function operates based on the provided index of the current row.
 * @param rows - The Ref array of rows (with objects containing `key`, `value`, `description`, etc.)
 * @param index - The index of the current row in the `rows` array.
 */
export const removeRowIfEmpty = (rows: ParamsField[], index: number): void => {
  const currentRow = rows[index]
  const nextRow = rows[index + 1]
  const nextRowExists = !!nextRow

  if (currentRow.key === '' && currentRow.value === '' && currentRow.description === '') {
    if (nextRowExists && nextRow.key === '' && nextRow.value === '' && nextRow.description === '') {
      rows.splice(index + 1, 1)
    }
  }
}

export default {
  removeRowIfEmpty
}
